module.exports = __webpack_public_path__ + "static/media/EastHampton_8.49ec9074.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/EastHampton_8.JPG
// module id = 245
// module chunks = 0